import { planHasHistory, isLicenseDateExpired } from './planLimits';

/**
 * owner のライセンスが「履歴機能」の資格を満たすか（常に現在の状態で判定）。
 * プランが履歴対応(pro/trial)かつ status=active かつ未期限切れであること。
 * @param {object} ownerProfile - users/{owner_id} の中身
 */
export const ownerQualifiesForHistory = (ownerProfile) => {
  if (!ownerProfile) return false;
  const role = ownerProfile.role?.trim()?.toLowerCase();
  if (role === 'superadmin') return true; // superadmin が owner のイベントは常に資格あり
  const lic = ownerProfile.license || {};
  if (!planHasHistory(lic.plan)) return false;
  if (lic.status !== 'active') return false;
  if (lic.expires_at && isLicenseDateExpired(lic.expires_at)) return false;
  return true;
};

/**
 * 閲覧者がこのイベントの応募者履歴を閲覧できるか。
 * - superadmin: 常に可
 * - それ以外: イベントの owner が履歴資格を満たし、かつ閲覧者が
 *   そのイベントの owner 本人 or staff であること
 *
 * @param {object}  p
 * @param {string}  p.viewerRole       閲覧者の role
 * @param {string}  p.viewerUid        閲覧者の uid
 * @param {object}  p.event            events/{eventId}（owner_id を含む）
 * @param {object}  p.ownerProfile     users/{event.owner_id}
 * @param {boolean} p.isStaffOfEvent   閲覧者がこのイベントの staff か
 */
export const canViewHistory = ({ viewerRole, viewerUid, event, ownerProfile, isStaffOfEvent }) => {
  const role = viewerRole?.trim()?.toLowerCase();
  if (role === 'superadmin') return true;
  if (!event) return false;
  if (!ownerQualifiesForHistory(ownerProfile)) return false;
  if (viewerUid && event.owner_id === viewerUid) return true; // owner 本人
  if (isStaffOfEvent) return true;                             // そのイベントの staff
  return false;
};
